import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AppQueryProvider } from './lib/queryClient'
import './styles/tokens.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found')

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter basename={import.meta.env.VITE_BASE_PATH ?? '/'}>
      <AppQueryProvider>
        <App />
      </AppQueryProvider>
    </BrowserRouter>
  </StrictMode>,
)
